export default __webpack_public_path__ + "688c2bef0400349a28c62a97ac8bf01a.png";